/* import __COLOCATED_TEMPLATE__ from './ignored-user-list-item.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./ignored-user-list-item.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: "div",
  items: null,
  actions: {
    removeIgnoredUser(item) {
      this.onRemoveIgnoredUser(item);
    }
  }
}));